export enum ActivitiesSupport {
  None,
  Summary,
  Collecting
}
